export default __webpack_public_path__ + "static/media/Yun Mark of Immolation.63a3ea5a.jpg";